import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@src/query';
import { getGroupUsers } from './api';
import { useAuthEnabled } from '@src/hooks/useAuthStatus';

/**
 * Get users in the current group
 */
export const useQueryGroupUsers = () => {
  const authEnabled = useAuthEnabled();

  return useQuery({
    queryKey: QUERY_KEYS.userGroupUsers(),
    queryFn: getGroupUsers,
    staleTime: Infinity,
    gcTime: Infinity,
    enabled: authEnabled,
  });
};
